
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AddFrontdeskUser, IFrontdeskUsers } from '@shared/services/api/legacy/frontdeskusers-service/frontdeskusers-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class FrontdeskUsersService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${FrontdeskUsersService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events/{eventId}/frontdeskusers';

    public getFrontdeskUsers(eventId: string): Observable<SuccessResponse<IFrontdeskUsers> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IFrontdeskUsers>>(FrontdeskUsersService.URL.replace('{eventId}', eventId)).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addFrontdeskUsers(eventId: string, model: AddFrontdeskUser): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(FrontdeskUsersService.URL.replace('{eventId}', eventId), model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addFrontdeskUsersTicketHolders(eventId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(FrontdeskUsersService.URL.replace('{eventId}', eventId) + '/ticketholders', null).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteFrontdeskUser(eventId: string, id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(FrontdeskUsersService.URL.replace('{eventId}', eventId) + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
